import { State } from "infrontjs";

import messageTemplate from "./SurveyMessageTemplate.html";
import { openOverlay, closeOverlay, appHomeRoute } from "./SurveyOverlay";
import { _lcs } from "../../i18n";

/**
 * FeedbackState — the guest's own way into the house survey
 * (`#/feedback` from the menu drawer, `#/feedback/qr` from the printed
 * house QR code).
 *
 * Asks the core-api for a fresh anonymous link to the house's active default
 * survey and hands over to SurveyState. No auth guard: the QR code is scanned
 * by whoever holds it, and the API endpoint is public for the same reason.
 * The channel only tells the evaluation where the answers came from.
 */
export class FeedbackState extends State
{
    static ROUTE = "/feedback(/:via)";
    static ID = "feedback";

    showsBottomNav() { return false; }

    async enter()
    {
        this.root = openOverlay();
        this.addEventListener( this.root, "click", ( e ) =>
        {
            const action = e.target.closest( "[data-action]" )?.getAttribute( "data-action" );
            if ( action === "home" )
            {
                this.app.router.redirect( appHomeRoute( this.app ) );
            }
            else if ( action === "retry" )
            {
                this._open();
            }
        } );

        await this._open();
    }

    async exit()
    {
        closeOverlay();
    }

    async _open()
    {
        this._message( { icon : "mountain", title : _lcs( "Umfrage wird geladen …" ), loading : true } );

        const accommodationId = this.app.accommodation?.id;
        if ( !accommodationId )
        {
            return this._none();
        }

        const channel = this.routeParams.getParam( "via", "" ) === "qr" ? "qr" : "menu";
        try
        {
            const { result } = await this.app.api.post(
                "/survey/accommodation/" + encodeURIComponent( accommodationId ) + "/open", { channel } );
            if ( !this.app )
            {
                return;
            }
            if ( !result || +result.status !== 201 || !result.data?.token )
            {
                throw new Error( "Unexpected survey open response." );
            }
            this.app.router.redirect( "/survey/" + encodeURIComponent( result.data.token ) );
        }
        catch ( e )
        {
            console.error( e );
            if ( !this.app )
            {
                return;
            }
            if ( +e?.status === 404 )
            {
                return this._none();
            }
            this._message( { icon : "mountain", title : _lcs( "Keine Verbindung" ),
                text : _lcs( "Die Umfrage konnte nicht geladen werden. Prüfe deine Internetverbindung." ), retry : true, home : true } );
        }
    }

    _none()
    {
        this._message( { icon : "flag", title : _lcs( "Gerade gibt es keine Umfrage" ),
            text : _lcs( "Deine Gastgeber haben im Moment keine Umfrage aktiviert. Schau gern später noch einmal vorbei." ), home : true } );
    }

    _message( { icon, title, text = "", loading = false, retry = false, home = false } )
    {
        this.app.view.render( this.root, messageTemplate, { icon, title, text, loading, retry, home } );
    }
}
